export const ContentTypes = {
  IMAGE: "image",
  VIDEO: "video",
  PDF: "application/pdf"
};
